__turbopack_context__.v({
  "blue": "StatCircle-module__Lpjg4W__blue",
  "caption": "StatCircle-module__Lpjg4W__caption",
  "content": "StatCircle-module__Lpjg4W__content",
  "contentCompact": "StatCircle-module__Lpjg4W__contentCompact",
  "contentHero": "StatCircle-module__Lpjg4W__contentHero",
  "figureFill": "StatCircle-module__Lpjg4W__figureFill",
  "figureStroke": "StatCircle-module__Lpjg4W__figureStroke",
  "green": "StatCircle-module__Lpjg4W__green",
  "orange": "StatCircle-module__Lpjg4W__orange",
  "pod": "StatCircle-module__Lpjg4W__pod",
  "red": "StatCircle-module__Lpjg4W__red",
  "ring": "StatCircle-module__Lpjg4W__ring",
  "root": "StatCircle-module__Lpjg4W__root",
  "swirlArt": "StatCircle-module__Lpjg4W__swirlArt",
  "swirlWrap": "StatCircle-module__Lpjg4W__swirlWrap",
  "value": "StatCircle-module__Lpjg4W__value",
});
